import React, { FC } from 'react'
import InfoVendorContainer from 'containers/Vendors/Info'

const VendorInfoPage: FC = () => <InfoVendorContainer />

export default VendorInfoPage
